import { Link } from "react-router-dom";
import "./Header.css";
import Logo from "../Logo/Logo";
import GameSwitcher from "../GameSwitcher/GameSwitcher";
import ProfileDropdown from "./ProfileDropdown";
import { useFirebase } from "../../../contexts/FirebaseContext";

/**
 * Unified header component for both MK8DX and World games.
 * Features:
 * - Game switcher with logo as label on the left
 * - Navigation links in the center
 * - Profile dropdown on the right
 * 
 * @param {string} currentGame - Current game mode ('mk8dx' or 'world')
 */
export default function Header({ currentGame }) {
    const { auth } = useFirebase();

    // Determine navigation paths based on current game
    const buildPath = currentGame === 'mk8dx' ? '/mk8dx' : '/';
    const browsePath = currentGame === 'mk8dx' ? '/mk8dx/browse' : '/browse';

    return (
        <header>
            <div className="header-left">
                <GameSwitcher 
                    currentGame={currentGame} 
                    logoComponent={<Logo game={currentGame} />}
                />
            </div>
            
            <div className="header-center">
                <Link to={buildPath}>Build</Link>
                <Link to={browsePath}>Browse</Link>
            </div>
            
            <div className="header-right">
                <ProfileDropdown auth={auth} currentGame={currentGame} />
            </div>
        </header>
    );
}
